module.exports = __webpack_public_path__ + "media/assault1.7d484731.webm";